import { Controller } from "stimulus"

// Bugfix 31 (#1565): in het blok "Facturatie & bedrijfsgegevens" staan de
// bedrijfsvelden alleen open als de klant zakelijk gefactureerd wordt. Zonder
// JavaScript staan ze gewoon open. Wat al is ingevuld blijft bewaard, ook als
// de velden even verborgen zijn.
export default class extends Controller {
  static targets = ["type", "zakelijk"]

  connect() {
    this.toggle()
  }

  toggle() {
    const zakelijk = this.typeTargets.some((el) => el.checked && el.value === "business")
    this.zakelijkTargets.forEach((el) => {
      el.hidden = !zakelijk
    })
  }
}
